<app-wrapper>
    <div class="mb-9">
        <div class="mb-4">
            <div class="row g-3">
                <div class="col-auto">
                    <h2>
                        <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
                            <i class="fa-solid fa-arrow-left"></i>
                        </div>
                        Сторис
                    </h2>
                </div>
                <div class="col-auto flex-grow-1">
                </div>
                <div class="col-auto">
                    <button (click)="save()" [disabled]="formGroup.invalid" class="btn btn-primary">
                        <i class="fa-solid fa-save"></i>&nbsp;Сохранить
                    </button>
                </div>
            </div>
        </div>
        <div class="row g-5">
            <div class="col-12">
                <form class="card p-4" [formGroup]="formGroup">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <div class="form-floating mb-3">
                                    <input type="text" formControlName="name" class="form-control"
                                        placeholder="Название">
                                    <label>Название</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <div class="form-check form-switch mb-3">
                                    <input class="form-check-input" type="checkbox" name="isEnabled"
                                        formControlName="isEnabled">
                                    <label class="form-check-label">Активно</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <label>Основная картинка для сторис</label>
                            <div class="file-container">
                                <div class="file-square circle"
                                    [ngStyle]="getImageStyle(formGroup.value.basePost.mediaPath)">
                                    <input type="file" id="main-image" accept="image/*"
                                        (change)="selectFile($event, asFormGroup( formGroup.controls['basePost']))" />
                                    <label for="main-image">
                                        <i class="fa-solid fa-plus"></i>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-4 mb-2">
                            <b>Посты</b>
                        </div>
                    </div>
                    <div class="row">
                        @for ( item of getPosts(); track $index) {
                        @if(postIsVideo(item.value.mediaPath)){

                        <div class="col-md-2">
                            <label>Пост {{item.value.order}}</label>
                            <div class="file-container d-flex flex-column align-items-center"
                                [formGroup]="asFormGroup(item)">

                                <div class="file-square position-relative">
                                    <video muted [src]="'/'+item.value.mediaPath">
                                    </video>
                                    <input type="file" id="media-{{$index}}" accept="image/*, video/*"
                                        (change)="selectFile($event, asFormGroup(item))" />
                                    <label for="media-{{$index}}">
                                        <i class="fa-solid fa-plus"></i>
                                    </label>
                                </div>
                                <div class="form-floating mb-3">
                                    <input type="number" class="form-control" formControlName="seconds"
                                        placeholder="Время" />
                                    <label>Длительность</label>
                                </div>

                                <!-- Кнопки сортировки -->
                                <div class="sort-controls mt-2 d-flex justify-content-center gap-1">
                                    <button type="button" class="btn btn-sm btn-outline-secondary"
                                        (click)="postMove($index,-1)" [disabled]="$index === 0"
                                        title="Переместить влево">
                                        <i class="fa-solid fa-chevron-left"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-secondary"
                                        (click)="postMove($index, 1)" [disabled]="$index === getPosts().length - 1"
                                        title="Переместить вправо">
                                        <i class="fa-solid fa-chevron-right"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-danger"
                                        (click)="removeStoryPost($index)" title="Удалить пост">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        }@else{
                        <div class="col-md-2">
                            <label>Пост {{item.value.order}}</label>
                            <div class="file-container d-flex flex-column align-items-center"
                                [formGroup]="asFormGroup(item)">
                                <div class="file-square" [ngStyle]="getImageStyle(item.value.mediaPath)">
                                    <input type="file" id="media-{{$index}}" accept="image/*, video/*"
                                        (change)="selectFile($event, asFormGroup(item))" />
                                    <label for="media-{{$index}}">
                                        <i class="fa-solid fa-plus"></i>
                                    </label>
                                </div>
                                <div class="form-floating mb-3">
                                    <input type="number" class="form-control" formControlName="seconds"
                                        placeholder="Время" />
                                    <label>Длительность</label>
                                </div>
                                <!-- Кнопки сортировки -->
                                <div class="sort-controls mt-2 d-flex justify-content-center gap-1">
                                    <button type="button" class="btn btn-sm btn-outline-secondary"
                                        (click)="postMove($index,-1)" [disabled]="$index === 0"
                                        title="Переместить влево">
                                        <i class="fa-solid fa-chevron-left"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-secondary"
                                        (click)="postMove($index, 1)" [disabled]="$index === getPosts().length - 1"
                                        title="Переместить вправо">
                                        <i class="fa-solid fa-chevron-right"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-danger"
                                        (click)="removeStoryPost($index)" title="Удалить пост">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        }
                        }

                        <div class="col-md-2">
                            <label>Добавить пост</label>
                            <div class="file-container">
                                <div class="file-square">
                                    <input type="file" id="media-new" accept="image/*, video/*"
                                        (change)="addStoryPost($event)" />
                                    <label for="media-new">
                                        <i class="fa-solid fa-plus"></i>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    @if (isBusy) {
    <div class="overlay">
        <i class="fa-solid fa-spinner fa-spin"></i>
    </div>
    }
</app-wrapper>